import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { TextToSpeechPlayer } from "@bloomberg/media-ui-av";

import { selectCurrentSlug } from "~redux/features/transporter-slice";
import { CurrentStoryContext } from "~utils/currentStoryContext";
import { Tracker } from "~utils/tracker";

import styles from "./textToSpeech.module.css";

const textToSpeechTracker = new Tracker({
    action: "play",
    event: "trackTextToSpeech",
    category: "audio",
    label: "initial",
});

export function TextToSpeech() {
    const [isEventTracked, setIsEventTracked] = useState(false);

    const { story } = useContext(CurrentStoryContext);
    const { readingDuration, readingUrl } = story;

    const ttsRef = useRef<HTMLAudioElement>(null);
    const currentSlug = useSelector(selectCurrentSlug);
    const inView = currentSlug === story.slug;

    useEffect(() => {
        if (!inView) {
            ttsRef.current?.pause();
        }
    }, [inView, ttsRef]);

    const trackTextToSpeechClickEvent = () => {
        if (!isEventTracked) {
            setIsEventTracked(true);
            textToSpeechTracker.trackEvent();
            textToSpeechTracker.addCustomDimension(
                "mediaType",
                "audio_text-to-speech"
            );
        }
    };

    return (
        <div className={styles.textToSpeech} data-component="text-to-speech">
            <TextToSpeechPlayer
                url={readingUrl!}
                durationMs={readingDuration!}
                ref={ttsRef}
                preload="none"
                onClick={trackTextToSpeechClickEvent}
            />
        </div>
    );
}
